import http from './httpService';

export function createServiceOrder(contract) {
	return http.post('ServiceOrder', contract);
}
